import parseNavigation from './parseNavigation';

/** Menú del rol super administrador: `tipo id | título | ícono | url`, anidado por tabulación. */
const superAdminNavigation = parseNavigation(`
group admConsults | Consultas | verified_user
	item certificateNomineesHistory | Certificados nominados | person_pin | /certificates/consult/nominees
	item materialDelivery | Entrega de material | local_shipping | /adm/material-delivery
	item materialFactured | Facturacion de material | receipt | /adm/material/invoiced-info
	item materialTrasnformed | transformación de material | sync | /adm/material-transformed
	item certificatesInVerification | Certificados en verificación | hourglass_empty | /adm/certificates-verification
	item certificatesAvaibles | Certificados aprobados | done_all | /adm/certificates-avaibles
	item certificatesRejected | Certificados rechazados | cancel | /adm/certificates-rejected
	item certificatesHistory | Certificados recibidos/transferidos | swap_horiz | /adm/certificates-history
	item adminMaterialSaleRecords | Registro de ventas | receipt_long | /adm/consult/material-sale-records
	item adminManufactureRecords | Reporte de fabricación | precision_manufacturing | /adm/consult/manufacture-records
	item adminCircularityCertificates | Certificados de circularidad | recycling | /adm/consult/circularity-certificates
group admUsers | Usuarios | verified_user
	item companies | Compañias | business | /adm/users/companies
	item createCompanyVerifier | Crear Empresa Verificadora | add_business | /adm/users/company-verifier
group admCharges | Cobros | verified_user | /charges
group admParameters | Parametros | verified_user
	item dashboard | Dashboard de datos | dashboard | /adm/parameters/dashboard
`);

export default superAdminNavigation;
